import { render, staticRenderFns } from "./MsgElementShare.vue?vue&type=template&id=07f2a7dc&scoped=true"
import script from "./MsgElementShare.vue?vue&type=script&lang=js"
export * from "./MsgElementShare.vue?vue&type=script&lang=js"
import style0 from "./MsgElementShare.vue?vue&type=style&index=0&id=07f2a7dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f2a7dc",
  null
  
)

export default component.exports